import { REMINDERS_PAUSED_REASONS } from '@shared/core/billing'
import { ArrowRight } from 'lucide-react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Button, FormattedText } from 'src/modules/core/components'
import { useUpdatePaymentMethod } from 'src/modules/payment/hooks/use-update-payment-method'
import {
  buildUpgradePlansPath,
  resolveUpgradeSourcePage,
  UPGRADE_TRIGGER_BY_PAUSED_REASON,
} from 'src/modules/payment/utils/upgrade-funnel-navigation'
import type { EditEventPausedActionsProps } from './edit-event-paused-actions.interface'
import classes from './edit-event-paused-actions.module.scss'

export function EditEventPausedActions({ reason, saveDisabled }: EditEventPausedActionsProps) {
  const navigate = useNavigate()
  const { pathname, search } = useLocation()
  const { openUpdateCard, isAvailable, isAwaitingUpdate } = useUpdatePaymentMethod()
  const isPaymentPaused = reason === REMINDERS_PAUSED_REASONS.paymentPaused

  const handleUpgradeClick = () => {
    navigate(
      buildUpgradePlansPath({
        trigger: UPGRADE_TRIGGER_BY_PAUSED_REASON[reason],
        source_element: 'event_editor',
        source_page: resolveUpgradeSourcePage(pathname, new URLSearchParams(search)),
      }),
    )
  }

  return (
    <div className={classes.root}>
      <Button
        type="button"
        className={classes.upgradeButton}
        onClick={isPaymentPaused ? openUpdateCard : handleUpgradeClick}
        disabled={isPaymentPaused && !isAvailable}
        isLoading={isPaymentPaused && isAwaitingUpdate}
      >
        <FormattedText id={isPaymentPaused ? 'event.paused.updateCardButton' : 'event.paused.upgradeButton'} />
        <ArrowRight className={classes.arrow} aria-hidden="true" />
      </Button>
      <Button type="submit" variant="withBorder" className={classes.saveButton} disabled={saveDisabled}>
        <FormattedText id="event.paused.saveWithoutSending" />
      </Button>
      <span className={classes.caption}>
        <FormattedText
          id={isPaymentPaused ? 'event.paused.editor.captionPaymentPaused' : 'event.paused.editor.caption'}
        />
      </span>
    </div>
  )
}
